import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/general-view-2/DashboardView.vue"),
    meta: {
      requiresAuth: true,
    },
    // component: () =>
    //   import(
    //     /* webpackChunkName: "home" */ "../views/general-view/general-view.vue"
    //   ),
  },
  {
    path: "/vendas",
    name: "sales",
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/home-view.vue"),
  },
  {
    path: "/estoque",
    name: "stock",
    // route level code-splitting
    // this generates a separate chunk (stock.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "stock" */ "../views/stock-view.vue"),
  },
  {
    path: "/v1",
    name: "stock",
    // route level code-splitting
    // this generates a separate chunk (stock.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "stock" */ "../views/genaral-view-2/DashboardView.vue"
      ),
  },
  {
    path: "/dashboard-v2",
    name: "DashboardV2",
    component: () => import("../views/general-view-2/DashboardView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
